import { RightTopLeftBottomBackgroundEffect } from "@/components/backgroundEffect";

const features = [
  {
    name: "Innovation",
    description:
      "We are committed to pushing the boundaries of what's possible in robotics and developing innovative solutions that have a positive impact on society.",
  },
  {
    name: "Collaboration",
    description:
      "We believe in working together with other researchers, engineers, and innovators to achieve our goals and create even more impactful solutions.",
  },
  {
    name: "Excellence",
    description:
      "We strive for excellence in everything we do, from research and development to design and implementation.",
  },
  {
    name: "Passion",
    description:
      "We are passionate about robotics and the potential it has to transform the world we live in.",
  },
  {
    name: "Community",
    description:
      "We believe in building strong, supportive communities around robotics and using our skills and knowledge to make a positive difference in the world.",
  },
  {
    name: "Ethics",
    description:
      "We are committed to ethical and responsible practices in all aspects of our work, including safety, privacy, and inclusively",
  },
];

const Values = () => {
  return (
    <RightTopLeftBottomBackgroundEffect>
      <section>
        <div className="container my-10">
          <div className="mb-12">
            <h2 className="mb-4 text-start text-3xl font-extrabold sm:text-4xl">Our Values</h2>
            <p className="max-w-prose text-start text-lg text-slate-500">
              At our robotic team, we are guided by a set of core values that shape everything we
              do. These values are:
              {/* These values guide us in our daily work and inspire us to push
              the limits of what's possible in robotics. We truly believe that by staying true to
              these values, we can create a brighter future for all. */}
            </p>
          </div>

          <dl className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <p className="text-lg font-medium leading-6 text-slate-900 dark:text-slate-50">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 flex text-base text-slate-500 lg:py-0 lg:pb-4">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </section>
    </RightTopLeftBottomBackgroundEffect>
  );
};
export default Values;
